import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import Select from 'react-select';
import {dashboardUnderlined, SUB_DIR, URL} from '../../Config/appConfig';
import {Auth, Option} from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import util from '../../Util/util';
import '../../style/header.css';
import { reactSelectStyles } from '../constants';

const logo = require('../../resource/img/logo.svg');
const searchIcon = require('../../resource/img/search-header-default.svg');
const menuDefault = require('../../resource/img/menu-default.svg');
const menuFocused = require('../../resource/img/menu-focused.svg');
const settingsDefault = require('../../resource/img/setting-default.svg');
const settingsFocused = require('../../resource/img/setting-focused.svg');
const logoutDefault = require('../../resource/img/logout-default.svg');
const logoutFocused = require('../../resource/img/logout-focused.svg');
const border = require('../../resource/img/border.svg');

interface HeaderProps {
    showMemberPanel: boolean,
    auth: () => Auth,
    logout: () => void,
    setSelectedInsurer: (insurer: Option) => void
}

interface HeaderState {
    insurer: Option,
    insurerOptions: Option[],
    isDashboard: boolean,
    expand: boolean,
    settingIcon: string,
    logoutIcon: string
}

class Header extends React.Component<RouteComponentProps & HeaderProps, HeaderState> {
    public shouldExpand: boolean = false;
    public wrapperRef: HTMLDivElement;

    public constructor(props: HeaderProps) {
        super(props);
        this.state = {
            insurer: null,
            insurerOptions: [],
            isDashboard: dashboardUnderlined.indexOf(this.props.history.location.pathname.split('/')[2]) !== -1,
            expand: false,
            settingIcon: settingsDefault,
            logoutIcon: logoutDefault
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.changeInsurer = this.changeInsurer.bind(this);
        this.clickLogout = this.clickLogout.bind(this);
        this.clickExpand = this.clickExpand.bind(this);
    }

    public componentWillMount() {
        if (this.props.showMemberPanel && !this.props.isInsurer()) {
            const insurers = util.getInsurerOptions(this.props.auth().registeredCounterparties);
            this.setState({
                insurer: this.props.auth().insurer,
                insurerOptions: insurers
            });
        }
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickExpand);
    }

    public setWrapperRef(node: HTMLDivElement) {
        this.wrapperRef = node;
    }

    public changeInsurer(insurer: Option) {
        this.setState({
            insurer
        });
        this.props.setSelectedInsurer(insurer);
        this.props.history.push({
            pathname: URL.DASHBOARD,
            state: {
                insurerChanged: true
            }
        });
    }

    public handleHover(isSetting: boolean, icon: string) {
        if (isSetting) {
            this.setState({
                settingIcon: icon
            })
        }
        else {
            this.setState({
                logoutIcon: icon
            })
        }
    }

    public clickButton(event: React.MouseEvent<HTMLElement>, dest: string) {
        event.preventDefault();
        if (dest === URL.SETTINGS) {
            this.shouldExpand = false;
            this.setState({
                expand: false
            })
        }
        if ((dest === URL.SEARCH || dest === URL.SETTINGS) && this.state.isDashboard) {
            this.props.history.push({
                pathname: dest,
                state: {
                    fromDashboard: true
                }
            });
        }
        else this.props.history.push(dest);
    }

    public clickLogout(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.logout();
    }

    public clickExpand(event: any) {
        event.preventDefault();
        if ((event.type === 'click' || this.wrapperRef && !this.wrapperRef.contains(event.target)) && !this.shouldExpand) {
            const expand = this.state.expand;
            if (expand) document.removeEventListener('mousedown', this.clickExpand);
            else document.addEventListener('mousedown', this.clickExpand);
            this.setState({
                expand: !expand
            });
        }
    }

    public render() {
        let isEnquiry = this.props.history.location.pathname.split('/')[2] === SUB_DIR.ENQUIRY;

        return (
            <div className="header">
                <button className={`${isEnquiry ? "cmUnclickable" : ""}`} onClick={(e) => !isEnquiry && this.clickButton(e, URL.DASHBOARD)}>
                    <img className="headerLogo" src={logo}/>
                </button>
                {this.props.showMemberPanel &&
                <div className="headerPanel">
                    <div className="leftPanel">
                        {this.state.insurerOptions.length ?
                            <div className="insurerContainer">
                                <div className="insurerLabel">Insurance Company</div>
                                <Select
                                    styles={reactSelectStyles}
                                    className="react-select__container insurerOptions"
                                    classNamePrefix="react-select"
                                    options={this.state.insurerOptions}
                                    value={this.state.insurer}
                                    clearable={false}
                                    onChange={this.changeInsurer}/>
                            </div> : null}
                        <button className={`cmBoldText dashboardBtn ${this.state.isDashboard ? 'currentTab' : 'tab'}`}
                                onClick={(e) => this.clickButton(e, URL.DASHBOARD)}>Dashboard
                        </button>
                        <button className={`cmBoldText ${this.state.isDashboard ? 'tab' : 'currentTab'}`}
                                onClick={(e) => this.clickButton(e, URL.COVER_NOTE)}>Records
                        </button>
                    </div>
                    <div className="rightPanel">
                        <div className="rightPanelContainer">
                            <div className="searchContainer">
                                <img src={border}/>
                                <button className="searchBtn" onClick={(e) => this.clickButton(e, URL.SEARCH)}>
                                    <img src={searchIcon}/>
                                </button>
                                <img src={border}/>
                            </div>
                            <div className="userInfoContainer cmText">
                                <div className="cmBoldText username">{this.props.auth() ? this.props.auth().user.name : ''}</div>
                                <div className="companyName">{this.props.auth() ? this.props.auth().user.company : ''}</div>
                            </div>
                            <div className="userOptionsContainer" ref={this.setWrapperRef}>
                                <button className="userOptionsBtn" onClick={this.clickExpand}>
                                    <img height="20" width="20" src={this.state.expand ? menuFocused : menuDefault}/>
                                </button>
                                {this.state.expand &&
                                <div className="userOptions">
                                    <button className="settings"
                                            onClick={(e) => this.clickButton(e, URL.SETTINGS)}
                                            onMouseOver={(e) => this.handleHover(true, settingsFocused)}
                                            onMouseOut={(e) => this.handleHover(true, settingsDefault)}>
                                        <img src={this.state.settingIcon}/>
                                        <span>Settings</span>
                                    </button>
                                    <button className="logout" onClick={this.clickLogout}
                                            onMouseOver={(e) => this.handleHover(false, logoutFocused)}
                                            onMouseOut={(e) => this.handleHover(false, logoutDefault)}>
                                        <img src={this.state.logoutIcon}/>
                                        <span>Logout</span>
                                    </button>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(Header));



// WEBPACK FOOTER //
// ./src/Components/Header/Header.tsx